import React from 'react';
import Image from '../Image'

const Loader = () => {
    return (
        <div className='loader'>
            <Image
                src="logo/snowflake-light.svg"
                alt="Loader"
                className='loader-container'
            />
            <h1 className='loader-text'>
                Landing Pages, E-commerce y Web Apps
            </h1>
        </div>
    );
};

export default Loader;
